import * as React from 'react';
import type { SVGProps } from 'react';
const PeopleGroupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    a
    <path
      fill="#000"
      d="M6.178.692a1.354 1.354 0 1 1 0 2.708 1.354 1.354 0 0 1 0-2.708Zm0 2.146a.792.792 0 1 0 0-1.584.792.792 0 0 0 0 1.584Zm1.888 1.887h-.562a1.326 1.326 0 1 0-2.651 0H4.29a1.887 1.887 0 0 1 3.775 0ZM10.47 9.27a1.354 1.354 0 1 1 0 2.708 1.354 1.354 0 0 1 0-2.708Zm0 2.146a.792.792 0 1 0 0-1.584.792.792 0 0 0 0 1.584Zm1.887 1.893h-.562a1.328 1.328 0 0 0-2.657 0h-.561a1.89 1.89 0 0 1 3.78 0ZM1.887 9.269a1.354 1.354 0 1 1 0 2.707 1.354 1.354 0 0 1 0-2.707Zm0 2.146a.792.792 0 1 0 0-1.584.792.792 0 0 0 0 1.584Zm1.893 1.893h-.562a1.328 1.328 0 0 0-2.656 0H0a1.89 1.89 0 0 1 3.78 0Zm2.68-5.364h-.562v-2.68h.561v2.68ZM8.155 9.78 6.178 8.295 4.201 9.78l-.337-.45 2.314-1.74 2.315 1.74-.337.45Z"
    />
  </svg>
);
export default PeopleGroupIcon;
